/**
 * Utility for accessing application version information
 */

interface VersionInfo {
  version: string;
  buildDate: string;
}

// Get version from Vite environment variables or fallback to defaults
export const getVersionInfo = (): VersionInfo => {
  return {
    version: import.meta.env.VITE_APP_VERSION || "0.0.0",
    buildDate:
      import.meta.env.VITE_APP_BUILD_DATE ||
      new Date().toISOString().split("T")[0],
  };
};

export default getVersionInfo;
